import React from 'react';
import AppShell from '@/components/layout/AppShell';
import { adminNav } from '@/lib/navConfig';
import TransactionsHistory from '@/components/transactions/TransactionsHistory';

export default function AdminTransactions() {
  return (
    <AppShell nav={adminNav} title="Riwayat Transaksi">
      <TransactionsHistory />
    </AppShell>
  );
}
